import propTypes from 'prop-types';
import { Component } from 'react';

import {
  countUpTime
} from '../../utils';

class CountForward extends Component {
  state = {
    counter: countUpTime(this.props.updated_date)
  }

  componentDidMount() {
      this.timer = setInterval(this.tick, 1000);
      // this.setState({timer})
  }

  componentWillUnmount() {
      clearInterval(this.timer);
  }

  tick = () => {
      this.setState({
        counter: countUpTime(this.props.updated_date)
      })
  }

  render() {
    let {counter} = this.state
    return(
      <span id="count-up">
          {`${counter.days} Hari ${counter.hours} Jam ${counter.mins} Menit ${counter.secs} Detik`}
      </span>
    )
  }
}
CountForward.propTypes={
  updated_date: propTypes.string
}

CountForward.defaultProps={
  updated_date: "2018-01-29 18:07:33"
}

export default CountForward